import { render, staticRenderFns } from "./InquiryCompany.vue?vue&type=template&id=6d80864a&"
import script from "./InquiryCompany.vue?vue&type=script&lang=js&"
export * from "./InquiryCompany.vue?vue&type=script&lang=js&"
import style0 from "./InquiryCompany.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports